import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';
import { OpacityOptions } from '@framework/workbench/drawer/common/config';
import i18n from '@i18next/i18n';

export const SIZE_MAX = 150;

// 标识输入框属性属性变更回调的key
const INPUT_PROPS_KEY = ChartFormItemKey.CHART_GLOBAL_GLOW;

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.CUSTOM,
        name: ChartFormItemKey.CHART_GLOBAL_GLOW,
        content: '',
    },
    {
        type: FormItemType.CUSTOM,
        name: ChartFormItemKey.CHART_GLOBAL_GLOW_COLOR,
        options: {
        },
        style: {
            boxSizing: 'content-box',
        },
    },
    {
        type: FormItemType.SLIDER,
        name: ChartFormItemKey.CHART_GLOBAL_GLOW_SIZE,
        label: FormItemLabelName.SIZE,
        options: {
            suffix: i18n.t('磅'),
            max: SIZE_MAX,
            step: 1,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.SLIDER,
        name: ChartFormItemKey.CHART_GLOBAL_GLOW_OPICITY,
        label: FormItemLabelName.OPACITY,
        options: {
            ...OpacityOptions,
        },
        defaultValue: 0,
    },
];
